import { defineMessages } from 'react-intl';

const scope = 'dashboard.newsletters';

const messages = defineMessages({
  deleteConfirmationDialogTotal: {
    id: `${scope}.DeleteConfirmationDialog.total`,
    defaultMessage: '종료된 모든 가정통신문을 삭제하시겠습니까?{ br }(응답 중인 가정통신문은 종료 후 삭제할 수 있습니다.)',
  },
  deleteConfirmationDialogChecked: {
    id: `${scope}.DeleteConfirmationDialog.checked`,
    defaultMessage: '종료된 { count }개의 가정통신문을 삭제하시겠습니까?{ br }(응답 중인 가정통신문은 종료 후 삭제할 수 있습니다.)',
  },
  deleteConfirmationDialogCancelButton: {
    id: `${scope}.DeleteConfirmationDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteConfirmationDialogDeleteButton: {
    id: `${scope}.DeleteConfirmationDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteConfirmationDialogDeleteButtonAll: {
    id: `${scope}.DeleteConfirmationDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmationDialogDeleteButton: {
    id: `${scope}.DeleteReconfirmationDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteReconfirmationDialogDeleteButtonAll: {
    id: `${scope}.DeleteReconfirmationDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmationDialogCancelButton: {
    id: `${scope}.DeleteReconfirmationDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteReconfirmationDialog: {
    id: `${scope}.DeleteReconfirmationDialog`,
    defaultMessage: '정말 삭제하시겠습니까?{ br }삭제한 가정통신문은 복구할 수 없습니다.',
  },
  newslettersHeading: {
    id: `${scope}.Newsletters.Heading`,
    defaultMessage: '가정통신문',
  },
  newslettersSearchFieldPlaceholder: {
    id: `${scope}.Newsletters.SearchField.placeholder`,
    defaultMessage: '번호, 제목, 작성자 검색',
  },
  newslettersDraftStorageLink: {
    id: `${scope}.Button.draftStorageLink`,
    defaultMessage: '임시보관함',
  },
  newslettersFormLink: {
    id: `${scope}.Button.formLink`,
    defaultMessage: '작성하기',
  },
  newslettersMarkOngoing: {
    id: `${scope}.Mark.ongoing`,
    defaultMessage: '응답 중',
  },
  newslettersMarkClosed: {
    id: `${scope}.Mark.closed`,
    defaultMessage: '종료',
  },
  newsletterTableHeadNumber: {
    id: `${scope}.NewsletterTable.head.number`,
    defaultMessage: '번호',
  },
  newsletterTableHeadTitle: {
    id: `${scope}.NewsletterTable.head.title`,
    defaultMessage: '제목',
  },
  newsletterTableHeadWriter: {
    id: `${scope}.NewsletterTable.head.writer`,
    defaultMessage: '작성자',
  },
  newsletterTableHeadSendAt: {
    id: `${scope}.NewsletterTable.head.sendAt`,
    defaultMessage: '전송일',
  },
  newsletterTableHeadStatus: {
    id: `${scope}.NewsletterTable.head.status`,
    defaultMessage: '상태',
  },
  newsletterTableHeadResponse: {
    id: `${scope}.NewsletterTable.head.response`,
    defaultMessage: '응답',
  },
  newsletterTableBodyNumber: {
    id: `${scope}.NewsletterTable.body.number`,
    defaultMessage: '제{ year }-{ issueNumber }호',
  },
  newsletterTableSnackbar: {
    id: `${scope}.NewsletterTable.Snackbar`,
    defaultMessage: '가정통신문이 삭제되었습니다.',
  },
  tableToolBarUnselectButton: {
    id: `${scope}.TableToolBar.UnselectButton`,
    defaultMessage: '선택 해제',
  },
  tableToolBarSelectButton: {
    id: `${scope}.TableToolBar.SelectButton`,
    defaultMessage: '전체 선택',
  },
  tableToolBarDeleteButton: {
    id: `${scope}.TableToolBar.DeleteButton`,
    defaultMessage: '선택 삭제',
  },
  tableToolBarSelectInfo: {
    id: `${scope}.TableToolBar.SelectInfo`,
    defaultMessage: '{ count }개 선택됨',
  },
  tableToolBarSelectInfoAll: {
    id: `${scope}.TableToolBar.SelectInfo.all`,
    defaultMessage: '전체 선택됨',
  },
  newslettersTableFallbackMessageFiltered: {
    id: `${scope}.Newsletters.TableFallbackMessage.filtered`,
    defaultMessage: '해당하는 가정통신문이 없습니다. 필터를 다시 설정해보세요.',
  },
  newslettersTableFallbackMessageNoData: {
    id: `${scope}.Newsletters.TableFallbackMessage.noData`,
    defaultMessage: '작성한 가정통신문이 없습니다. 첫 번째 가정통신문을 작성해보세요!',
  },
  gradeFilterLabel: {
    id: `${scope}.GradeFilter.label`,
    defaultMessage: '{ grade }학년',
  },
  gradeFilterLabelAll: {
    id: `${scope}.GradeFilter.label.all`,
    defaultMessage: '전체 보기',
  },
  gradeFilterSelectLabel: {
    id: `${scope}.GradeFilter.Select.label`,
    defaultMessage: '응답 대상',
  },
  rowsPerPageFilterLabel: {
    id: `${scope}.RowsPerPageFilter.label`,
    defaultMessage: '{ num }개씩 보기',
  },
  statusFilterLabelAll: {
    id: `${scope}.StatusFilter.label.all`,
    defaultMessage: '전체 보기',
  },
  statusFilterLabelOngoing: {
    id: `${scope}.StatusFilter.label.ongoing`,
    defaultMessage: '응답 중',
  },
  statusFilterSelectLabel: {
    id: `${scope}.StatusFilter.Select.label`,
    defaultMessage: '응답 상태',
  },
  statusFilterLabelClosed: {
    id: `${scope}.StatusFilter.label.closed`,
    defaultMessage: '종료',
  },
  targetListDialogButton: {
    id: `${scope}.TargetListDialog.Button`,
    defaultMessage: '미응답자에게 알림 재전송',
  },
  targetListDialogHeading: {
    id: `${scope}.TargetListDialog.Heading`,
    defaultMessage: '응답 확인',
  },
  yearFilterLabel: {
    id: `${scope}.YearFilter.label`,
    defaultMessage: '{ year }년도',
  },
  yearFilterLabelAll: {
    id: `${scope}.YearFilter.label.all`,
    defaultMessage: '전체 보기',
  },
  yearFilterSelectLabel: {
    id: `${scope}.YearFilter.Select.label`,
    defaultMessage: '연도',
  },
});

export default messages;
